import React from 'react';
import c from 'classnames';

import { SearchPagination } from '@uncinc/react-searchkit';

import './style.scss';

export interface SearchGeneralPaginationProps {
  className?: string;
}

// @TODO RSK: Add className prop and export props.
const SearchGeneralPagination: React.FC<SearchGeneralPaginationProps> = (props) => {
  const { className } = props;

  const classNames = c('SearchGeneral__Pagination', className);

  return (
    <div className={classNames}>
      <SearchPagination />
    </div>
  );
};

export default SearchGeneralPagination;
